<template>
  <div>
    <div v-if="!componentView">Loading permits...</div>
    <component :is="componentView" v-else/>
  </div>
</template>

<script>
import axios from "axios"

export default {
  data() {
    return {
      componentView: null
    }
  },
  async created() {
    try {
      const res = await axios.get("https://mware-aksiteknologi.com/api/ags/permit/version")

      const version = res.data.version

      if (version === "v2") {
        this.componentView = () => import("../views/Permits.vue")
      } else {
        this.componentView = () => import("../views/PermitsV1.vue")
      }

    } catch (e) {
      console.error(e)

      // fallback
      this.componentView = () => import("../views/PermitsV1.vue")
    }
  }
}
</script>